import WIDGETS from './widgets';

export default {
	name: 'assign_ticket_survey',
	spacing: 2,
	sx: {
		width: '100%',
		margin: '0px',
		// paddingBottom: (theme) => theme.spacing(2)
	},
	widgets: [{ content: WIDGETS.ASSIGN_TICKET_SURVEY, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 }],
};
